export default __webpack_public_path__ + "static/media/shed-finished.1f797b0e.png";